import React, { createContext, useState, useEffect, useCallback } from 'react';
import { jwtDecode } from 'jwt-decode';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('jwtToken'));

  const [isLoading, setIsLoading] = useState(true);

  const initializeAuth = useCallback(() => {
    const storedToken = localStorage.getItem('jwtToken');
    if (storedToken) {
      try {
        const decodedToken = jwtDecode(storedToken);
        const currentTime = Date.now() / 1000;
        if (decodedToken.exp < currentTime) {
          localStorage.removeItem('jwtToken');
          localStorage.removeItem('user');
          setUser(null);
          setToken(null);
        } else {
          setToken(storedToken);
          const storedUser = localStorage.getItem('user');
          if (storedUser) {
            setUser(JSON.parse(storedUser));
          } else {
             setUser({ username: decodedToken.sub, role: decodedToken.role });
          }
        }
      } catch (error) {
        console.error("Error decoding token on initial load:", error);
        localStorage.removeItem('jwtToken');
        localStorage.removeItem('user');
        setUser(null);
        setToken(null);
      }
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    initializeAuth();
  }, [initializeAuth]);


  const login = (jwtToken, userRole, username) => {
    localStorage.setItem('jwtToken', jwtToken);
    const userDetailsToStore = {
        username: username,
        role: userRole
    };
    localStorage.setItem('user', JSON.stringify(userDetailsToStore));

    setUser(userDetailsToStore);
    setToken(jwtToken);
  };

  const logout = () => {
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('user');
    setUser(null);
    setToken(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, isLoading, initializeAuth }}>
      {children}
    </AuthContext.Provider>
  );
};